import "./Footer.css";

const COMPANY_LINKS = [
	{ label: "About", href: "/about" },
	{ label: "Contact", href: "/contact" },
];

const RESOURCE_LINKS = [
	{ label: "Homepage", href: "/" },
	{ label: "Pricing", href: "/pricing" },
];

const BOTTOM_LINKS = [
	{ label: "Privacy", href: "/privacy" },
	{ label: "Brandbook", href: "/brandbook" },
];

const AppFooter = () => {
	const year = new Date().getFullYear();

	return (
		<footer className="app-footer">
			<div className="app-footer-inner">
				<div className="app-footer-grid">
					<div className="app-footer-brand">
						<h3 className="app-footer-brand-title">BodhiStreams</h3>
						<p className="app-footer-tagline">
							Transform your space with premium wellness music curated for
							meditation and mindful living.
						</p>
					</div>

					<div>
						<h4 className="app-footer-col-title">Company</h4>
						<ul className="app-footer-links">
							{COMPANY_LINKS.map((item) => (
								<li key={item.label}>
									<a className="app-footer-link" href={item.href}>
										{item.label}
									</a>
								</li>
							))}
						</ul>
					</div>

					<div>
						<h4 className="app-footer-col-title">Resources</h4>
						<ul className="app-footer-links">
							{RESOURCE_LINKS.map((item) => (
								<li key={item.label}>
									<a className="app-footer-link" href={item.href}>
										{item.label}
									</a>
								</li>
							))}
						</ul>
					</div>

					<div>
						<h4 className="app-footer-col-title">Coming Soon</h4>
						<div className="app-footer-badges">
							<img
								className="app-footer-badge"
								src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
								alt="App Store"
							/>
							<img
								className="app-footer-badge"
								src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
								alt="Play Store"
							/>
						</div>
						<p className="app-footer-coming-hint">Mobile apps launching soon</p>
					</div>
				</div>

				<div className="app-footer-bottom">
					<p className="app-footer-copyright">
						© {year} BodhiStreams. All rights reserved.
					</p>
					<div className="app-footer-bottom-links">
						{BOTTOM_LINKS.map((item) => (
							<a
								key={item.label}
								className="app-footer-bottom-link"
								href={item.href}
							>
								{item.label}
							</a>
						))}
					</div>
				</div>
			</div>
		</footer>
	);
};

export default AppFooter;
